import React from 'react';
import { Box } from '@mui/material';
import type { PageConfig } from '../../types/settings';
import { SuperSection } from '../structure';
import { usePageTitle } from '../../hooks';
import { LanguageSwitcher } from '../../i18n';
import { pageGutterX } from '../../theme/tokens';

interface LayoutDefaultProps {
  page: PageConfig;
}

/** Nome da seção do cabeçalho em `mainpage.json` — o seletor vem logo depois dela. */
const HEADER_SECTION = 'header';

export function LayoutDefault({ page }: LayoutDefaultProps) {
  usePageTitle(page.title);

  // A divisão é pela estrutura da página, não pela marca: toda página com
  // seção `header` ganha o seletor logo abaixo dela; sem `header` (ou com ele
  // oculto pelo settings da marca), o seletor fica no topo.
  const headerSections = page.sections.filter((section) => section.name === HEADER_SECTION);
  const bodySections = page.sections.filter((section) => section.name !== HEADER_SECTION);

  return (
    <div className="layout layout--default">
      <SuperSection sections={headerSections} />
      {/*
        O seletor de idioma fica no layout, como no `link-venda-direta`
        (`src/layouts/index.tsx`). Sem ele a detecção automática por IP vira uma
        via de mão única: quem cai num idioma que não fala não tem como voltar.

        Barra própria na largura TODA da tela — sem o limite de 1280px do
        cabeçalho —, então a bandeira fica sempre junto à borda direita da
        janela, em qualquer monitor ou dispositivo. Só o recuo lateral
        (`pageGutterX`) é o mesmo do cabeçalho. O flex de fora impede que o
        botão estique na largura toda do `.layout` (coluna flex): esticado, a
        bandeira ficava à esquerda e o menu — ancorado na borda direita do
        botão — abria do outro lado da tela.
      */}
      <Box
        data-testid="language-bar"
        sx={{
          width: '100%',
          boxSizing: 'border-box',
          px: pageGutterX,
          pt: 1.5,
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <LanguageSwitcher />
      </Box>
      <SuperSection sections={bodySections} />
    </div>
  );
}
